import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  connect = () => {
    on('openArModal', this.updateUrl)
  }

  disconnect = () => {
    off('openArModal', this.updateUrl)
  }

  updateUrl = (event) => {
    this.element.dataset.buttonUrlValue = event.detail.url
  }
}
